import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Alert,
  AlertDescription,
  AlertTitle,
  Box,
  Button,
  Checkbox,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Icon,
  Input as ChakraInput,
  Radio,
  RadioGroup,
  Spinner,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';
import { Divider, Flex, Link, Spacer, Stack } from '@chakra-ui/layout';
import { useForm } from 'react-hook-form';
import { v4 as uuid } from 'uuid';
import { FaInfoCircle } from 'react-icons/fa';
import { FiCheck, FiX } from 'react-icons/all';
import { DefaultDiscountVIew } from '~/types/discount';
import {
  useExtensionDiscounts,
  useNotExtendingReasons,
} from '~/hooks/useExtensions/useExtensions';
import api from '~/utils/api';
import { queryClient } from '~/utils/react-query';
import { parse } from '~/services/Extensions';
import { formatCurrency } from '~/utils/formatCurrency';
import { ROUTER_PATHS } from '~/constants';
import { Datepicker, Input, ReactSelect, Table, Textarea } from '~/components';
import {
  AutomaticAnalysis,
  ContractEquipment,
  ContractView,
  SelectItem,
  StatusExtensaoIdEnum,
} from '~/types';
import { ReasonForm } from './ReasonForm';
import { FileUploader } from '~/components/FileInput';
import { EquipmentSuggestion } from '~/pages/Portal/Contract/EquipmentSuggestion';
import { ContractEquipamentValues } from '~/pages/Portal/Contract/ContractEquipamentsValues';
import { getAutomaticAnalysis } from '~/services';
import { useContract } from '~/hooks';
import { ProposalDiscounts } from '~/types/extensionProposal';

interface AnalyseContractExtensionModalProps {
  id_contrato: string;
  trigger: React.ReactNode;
}

export const AnalyseContractExtensionModal: React.FC<AnalyseContractExtensionModalProps> =
  ({ id_contrato, trigger }: AnalyseContractExtensionModalProps) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const btnRef = useRef(null);
    const {
      data: contract,
      isLoading: isLoadingContract,
      refetch: refetchContract,
    } = useContract(Number(id_contrato));
    const toast = useToast();
    const {
      register,
      handleSubmit,
      setValue,
      reset,
      setError,
      formState,
      clearErrors,
      control,
    } = useForm();
    const { errors } = formState;
    const [approveAutoAnalysis, setApproveAutoAnalysis] = useState('1');
    const [disapproveReason, setDisapproveReason] = useState('');
    const [elegivel, setElegivel] = useState('1');
    const [manutencao, setManutencao] = useState('1');
    const [renovacao, setRenovacao] = useState(true);
    const [checkedItems, setCheckedItems] = useState<DefaultDiscountVIew[]>([]);
    const inputRef = useRef<HTMLInputElement | null>(null);
    const [podeAnexarTermo, setPodeAnexarTermo] = useState(
      contract?.precisa_termo_extensao || false,
    );
    const {
      data,
      isLoading,
      isFetching: discountIsFetching,
      refetch,
      isError,
    } = useExtensionDiscounts(id_contrato.toString());

    const {
      data: reasonsData,
      isLoading: reasonsIsLoading,
      isFetching: reasonsIsFetching,
      refetch: reasosnRefetch,
      isError: reasonsIsError,
    } = useNotExtendingReasons();

    const [isFetching, setFetching] = useState(false);
    const [discountList, setDiscountList] = useState<DefaultDiscountVIew[]>([]);

    const [nomeArquivo, setNomeArquivo] = useState<string | undefined>('');
    const [arquivo, setSelectedFile] = useState<any>();
    const [motivo, setMotivo] = useState<string>('');
    const [nuTermo, setNuTermo] = useState<string>('');
    const [dataColeta, setDataColeta] = useState<Date>(() => {
      let vencimentoFinal = new Date();
      if (contract?.vencimento_final) {
        const d = contract.vencimento_final.split('-');
        vencimentoFinal = new Date(
          parseInt(d[0], 10),
          parseInt(d[1], 10) - 1,
          parseInt(d[2], 10),
        );
      }
      vencimentoFinal.setDate(vencimentoFinal.getDate() + 30);
      return vencimentoFinal;
    });
    const [reasons, setReasons] = useState<SelectItem[]>([]);

    const [servicoInspecao, setServicoInspecao] = useState(false);
    const [servicoDesinstalacao, setServicoDesinstalacao] = useState(false);
    const [servicoEmbalagem, setServicoEmbalagem] = useState(false);

    const [equipamentos, setEquipamentos] = useState<ContractEquipment[]>([]);
    const [isLoadingEquipamentos, setIsLoadingEquipamentos] = useState(false);
    const [automaticAnalysisData, setAutomaticAnalysisData] =
      useState<AutomaticAnalysis>();
    const [automaticAnalysisIsFetching, setAutomaticAnalysisIsFetching] =
      useState(false);
    const [automaticAnalysisError, setAutomaticAnalysisError] = useState(false);

    useEffect(() => {
      if (!contract?.proposta_extensao) {
        setDiscountList(data || []);
      }
    }, [data]);

    useEffect(() => {
      if (elegivel === '1') {
        carregarEquipamentos();
      }
    }, [elegivel]);

    useEffect(() => {
      // verificar se o id existe na lista e setar o novo valor
      const novo = reasonsData?.filter(it => {
        return reasons.find(item => item.value === it.value);
      });
      setReasons(novo || []);
    }, [reasonsData]);

    const parseDate = (date: string | undefined) => {
      if (date) {
        const d = date?.split('-');
        return new Date(
          parseInt(d[0], 10),
          parseInt(d[1], 10) - 1,
          parseInt(d[2], 10),
        );
      }
      return new Date();
    };

    const newExpirationDate = (date: Date, daysInFuture = 1) => {
      date.setDate(date.getDate() + daysInFuture);
      return date;
    };

    const getUltimoValorContrato = (
      contrato: ContractView | undefined,
    ): number => {
      if (contrato && contrato.extensoes.length > 1) {
        return Number(
          contrato.extensoes.filter(item => item.ultimo_aditivo)[0]
            .vr_totalmensalinstrumento,
        );
      }
      return Number(contrato?.vr_mensal_atual) || 0;
    };

    const handleFileChange = (_file: File | null) => {
      setSelectedFile(_file);
      setNomeArquivo(_file ? _file.name : '');
      clearErrors('arquivo');
    };

    const clearFile = () => {
      setSelectedFile(null);
      setNomeArquivo('');
      setValue('arquivo', null);
    };

    const handleOpen = () => {
      callAutomaticAnalysis();
      config();
      onOpen();
    };
    const callAutomaticAnalysis = () => {
      setAutomaticAnalysisIsFetching(true);
      setAutomaticAnalysisError(false);
      getAutomaticAnalysis(id_contrato)
        .then(r => {
          setAutomaticAnalysisData(r);
          setDisapproveReason(r.motivo || '');
          handleApproveAutoAnalysis(r.motivo ? '2' : '1', r);
          config();
        })
        .catch(async err => {
          setAutomaticAnalysisError(true);
          clearValues();
          setDisapproveReason('');
          setApproveAutoAnalysis('1');
          config();
        })
        .finally(() => {
          queryClient.invalidateQueries(['contract', id_contrato]);
          queryClient.invalidateQueries(['contratos_noventa_dias']);
          setAutomaticAnalysisIsFetching(false);
        });
    };

    const handleClose = () => {
      clearValues();
      setApproveAutoAnalysis('1');
      setDisapproveReason('');
      config();
      onClose();
    };

    const clearValues = () => {
      setDiscountList(data || []);
      setCheckedItems([]);
      setManutencao('1');
      setRenovacao(true);
      setElegivel('');
      setServicoDesinstalacao(false);
      setServicoEmbalagem(false);
      setServicoInspecao(false);
      setDataColeta(
        newExpirationDate(parseDate(contract?.vencimento_final), 30),
      );
      setMotivo('');
      setNuTermo(contract?.nu_termo_sugerido || '');
      setReasons([]);
      clearFile();
      setPodeAnexarTermo(contract?.precisa_termo_extensao || false);
      setEquipamentos([]);
      clearErrors();
    };

    const minCollectDate = newExpirationDate(
      parseDate(contract?.vencimento_final),
    );

    const config = () => {
      if (contract?.proposta_extensao) {
        setElegivel(contract?.proposta_extensao?.elegivel ? '1' : '2');
        if (contract?.proposta_extensao?.elegivel) {
          const discounts = contract?.proposta_extensao?.descontos.map(
            (discount: ProposalDiscounts) => {
              return {
                id: uuid(),
                tempo_extensao: discount.prazo,
                desconto_padrao: discount.desconto,
                formattedDescontoPadrao: formatCurrency(
                  parse(String(discount.desconto)),
                ).replace('R$', ''),
              } as unknown as DefaultDiscountVIew;
            },
          );
          setCheckedItems(discounts);
          setDiscountList(discounts);
          setNomeArquivo(contract?.proposta_extensao?.anexo_termo_extensao);
          setRenovacao(contract?.proposta_extensao?.renovacao_automatica);
          setManutencao(
            contract?.proposta_extensao?.manutencao_preventiva ? '1' : '2',
          );
        } else {
          setMotivo(contract?.proposta_extensao?.motivo_cliente);
          setServicoDesinstalacao(
            contract?.proposta_extensao?.servico_desinstalacao,
          );
          setServicoEmbalagem(contract?.proposta_extensao?.servico_embalagem);
          setServicoInspecao(contract?.proposta_extensao?.servico_inspecao);
          if (contract?.proposta_extensao?.data_limite_coleta_equipamento) {
            setDataColeta(
              parseDate(
                contract?.proposta_extensao?.data_limite_coleta_equipamento,
              ),
            );
          }
          setReasons(
            contract?.proposta_extensao?.motivos.map(m => {
              return {
                label: m.motivo,
                value: m.id.toString(),
              };
            }),
          );
        }
      }
    };

    const handleDesconto = (
      e: React.FormEvent<HTMLInputElement>,
      desconto: DefaultDiscountVIew,
    ) => {
      const value = parse(e.currentTarget.value);
      let index = checkedItems.findIndex(item => item.id === desconto.id);

      if (index > -1) {
        setCheckedItems([
          ...checkedItems.slice(0, index),
          {
            ...checkedItems[index],
            desconto_padrao: value,
            formattedDescontoPadrao: formatCurrency(value).replace('R$', ''),
          } as unknown as DefaultDiscountVIew,
          ...checkedItems.slice(index + 1),
        ]);
      }

      index = discountList.findIndex(item => item.id === desconto.id);

      setDiscountList([
        ...discountList.slice(0, index),
        {
          ...discountList[index],
          desconto_padrao: value,
          formattedDescontoPadrao: formatCurrency(value).replace('R$', ''),
        } as unknown as DefaultDiscountVIew,
        ...discountList.slice(index + 1),
      ]);
      clearErrors(`descontos${desconto.id}`);
    };

    const handleElegivel = (e: string) => {
      clearValues();
      setElegivel(e);
      clearErrors();
      if (e === '1' && !equipamentos.length) {
        carregarEquipamentos();
      }
    };

    const existsInCheckedItems = (desconto: DefaultDiscountVIew) => {
      return checkedItems.some(item => item.id === desconto.id);
    };

    const handleCheckbox = (desconto: DefaultDiscountVIew) => {
      const index = checkedItems.findIndex(item => item.id === desconto.id);
      if (index > -1) {
        // desconto removido
        setCheckedItems([
          ...checkedItems.slice(0, index),
          ...checkedItems.slice(index + 1),
        ]);
        clearErrors(`descontos${desconto.id}`);
      } else {
        // desconto adicionado
        setCheckedItems([...checkedItems, desconto]);
        clearErrors('descontos');
      }
    };

    const handleMotivo = (e: React.FormEvent<HTMLTextAreaElement>) => {
      setMotivo(e.currentTarget.value);
      clearErrors('motivo');
    };

    const handleNuTermo = (e: React.FormEvent<HTMLInputElement>) => {
      setNuTermo(e.currentTarget.value);
      clearErrors('nu_termo');
    };

    const handleDataColeta = (date: Date) => {
      clearErrors('dataColeta');
      setDataColeta(date);
    };

    const handleRenovacao = () => {
      setRenovacao(!renovacao);
    };

    const handleReasonsChanges = (items: SelectItem[]) => {
      setReasons(items);
      clearErrors('motivos');
    };

    const handleApproveAutoAnalysis = (e: string, r: AutomaticAnalysis) => {
      clearValues();
      setApproveAutoAnalysis(e);
      handleElegivel(
        e === '2' ? (r.resultado ? '2' : '1') : r.resultado ? '1' : '2',
      );
      clearErrors();
    };

    const handleDisapproveReason = (
      e: React.FormEvent<HTMLTextAreaElement>,
    ) => {
      setDisapproveReason(e.currentTarget.value);
      clearErrors('disapproveReason');
    };

    const verificarPodeAnexarTermo = async () => {
      if (nuTermo.length === 0) {
        return;
      }
      const response = api.get<{ precisa_anexo: boolean }>(
        `contratos/${id_contrato}/nu-termo/${nuTermo}`,
      );
      response
        .then(res => {
          setPodeAnexarTermo(res.data.precisa_anexo);
        })
        .catch(err => {
          toast({
            title: err.response.data.detail,
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top-right',
          });
        });
    };

    const carregarEquipamentos = () => {
      if (!visualization) {
        setIsLoadingEquipamentos(true);
        const request = api.get<ContractEquipment[]>(
          `/proposta_extensao/equipamentos_valores?contrato_id=${id_contrato}`,
        );
        request
          .then(res => {
            const dataFormatted = res.data.map(item => ({
              ...item,
              valor_mensal: Number(Number(item.valor_mensal).toFixed(2)),
            }));
            setEquipamentos(dataFormatted);
          })
          .catch(e => {
            setEquipamentos([]);
          })
          .finally(() => setIsLoadingEquipamentos(false));
      } else {
        const equipaments: ContractEquipment[] = [];
        contract?.proposta_extensao?.equipamentos.forEach(item => {
          equipaments.push({
            cd_equipamento: item.cd_equipamento,
            ds_equipamento: item.ds_equipamento,
            tipo_equipamento: item.tipo_equipamento,
            id: item.id,
            quantidade: item.quantidade,
            quantidade_original: item.quantidade_original,
            valor_mensal: Number(Number(item.valor_mensal).toFixed(2)),
            valor_mensal_unitario: item.valor_mensal_unitario,
          });
        });
        setEquipamentos(equipaments || []);
      }
    };

    const podeEstenderElegivel = elegivel === '1' && equipamentos.length > 0;

    const visualization =
      contract?.status_proposta !==
        StatusExtensaoIdEnum.AGUARDANDO_ANALISE_EXTENSAO &&
      contract?.status_proposta !==
        StatusExtensaoIdEnum.ELEGIVEL_EXTENSAO_ANALISE_AUTOMATICA &&
      contract?.status_proposta !==
        StatusExtensaoIdEnum.NAO_ELEGIVEL_EXTENSAO_ANALISE_AUTOMATICA;

    const validate = () => {
      clearErrors();
      elegivel === '1' &&
        checkedItems.forEach(desconto => {
          if (
            Number(desconto.desconto_padrao) <
              Number(desconto.desconto_minimo) ||
            Number(desconto.desconto_padrao) > Number(desconto.desconto_maximo)
          ) {
            setError(`descontos${desconto.id}`, {
              type: 'validate',
              message: `Desconto deve ser entre ${Number(
                desconto.desconto_minimo,
              )
                .toString()
                .replace('.', ',')} e ${Number(desconto.desconto_maximo)
                .toString()
                .replace('.', ',')} %`,
            });

            !desconto.desconto_padrao &&
              setError(`descontos${desconto.id}`, {
                type: 'required',
                message: 'Campo obrigatório',
              });
          }
        });
      !visualization &&
        podeAnexarTermo &&
        elegivel === '1' &&
        !(arquivo || nomeArquivo) &&
        setError('arquivo', {
          type: 'required',
          message: 'Arquivo é obrigatório',
        });
      elegivel === '1' &&
        checkedItems.length === 0 &&
        setError('descontos', {
          type: 'required',
          message: 'Selecione ao menos um desconto',
        });

      elegivel === '2' &&
        reasons.length === 0 &&
        setError('motivos', {
          type: 'required',
          message: 'Campo obrigatório',
        });

      elegivel === '2' &&
        !dataColeta &&
        setError('dataColeta', {
          type: 'required',
          message: 'Campo obrigatório',
        });

      elegivel === '2' &&
        motivo.trim().length === 0 &&
        setError('motivo', {
          type: 'required',
          message: 'Campo obrigatório',
        });

      approveAutoAnalysis === '2' &&
        disapproveReason.trim().length === 0 &&
        setError('disapproveReason', {
          type: 'required',
          message: 'Campo obrigatório',
        });

      approveAutoAnalysis === '2' &&
        disapproveReason.length > 255 &&
        setError('disapproveReason', {
          type: 'maxLength',
          message: 'Motivo com mais de 255 caracteres',
        });

      elegivel === '2' &&
        dataColeta < minCollectDate &&
        setError('dataColeta', {
          type: 'min',
          message: `Data da coleta não pode ser menor que ${minCollectDate.toLocaleDateString(
            'br',
          )}`,
        });

      elegivel === '2' &&
        motivo.length > 255 &&
        setError('motivo', {
          type: 'maxLength',
          message: 'Motivo com mais de 255 caracteres',
        });
      !contract?.nu_termo_segue_padrao &&
        nuTermo.trim().length === 0 &&
        setError('nu_termo', {
          type: 'required',
          message: 'Campo obrigatório',
        });
      const { _formState } = control;
      return _formState.isValid;
    };

    const handleCreate = async () => {
      if (!validate()) {
        return;
      }
      setFetching(true);
      const updateData = {
        renovacao_automatica: renovacao,
        equipamentos: JSON.stringify(equipamentos),
      };
      const form = new FormData();
      form.append('contrato', id_contrato.toString());
      if (automaticAnalysisData?.id) {
        form.append(
          'contrato_analise_automatica',
          automaticAnalysisData.id.toString(),
        );
        if (disapproveReason) {
          form.append('motivo_recomendacao', disapproveReason);
        }
      }

      form.append('elegivel', elegivel === '1' ? 'true' : 'false');
      !contract?.nu_termo_segue_padrao && form.append('nu_termo', nuTermo);
      if (elegivel === '1') {
        discountList.forEach(desconto => {
          if (checkedItems.some(item => item.id === desconto.id)) {
            form.append(
              'descontos',
              JSON.stringify({
                desconto: desconto.desconto_padrao.toString(),
                prazo: desconto.tempo_extensao.toString(),
                id_desconto: desconto.id,
              }),
            );
          }
        });
        form.append(
          'manutencao_preventiva',
          manutencao === '1' ? 'true' : 'false',
        );
        form.append('renovacao_automatica', renovacao ? 'true' : 'false');
        if (arquivo && podeAnexarTermo) {
          form.append('anexo_termo_extensao', arquivo);
        }
        equipamentos.forEach(eq => {
          form.append('equipamentos', JSON.stringify(eq));
        });
      } else {
        form.append('servico_inspecao', servicoInspecao ? 'true' : 'false');
        form.append(
          'data_limite_coleta_equipamento',
          dataColeta.toISOString().substring(0, 10),
        );
        form.append('motivo_cliente', motivo);
        form.append(
          'servico_desinstalacao',
          servicoDesinstalacao ? 'true' : 'false',
        );
        form.append('servico_embalagem', servicoEmbalagem ? 'true' : 'false');

        reasons.forEach(reason => {
          form.append(
            'motivos',
            JSON.stringify({
              id_motivo: reason.value,
            }),
          );
        });
      }

      const request = !visualization
        ? api.post(`proposta_extensao/`, form)
        : api.put(
            `proposta_extensao/${contract?.proposta_extensao?.id}`,
            updateData,
          );

      request
        .then(() => {
          toast({
            title: !visualization
              ? 'Proposta adicionada'
              : 'Proposta atualizada',
            status: 'success',
            duration: 3000,
            isClosable: true,
            position: 'top-right',
          });
          queryClient.invalidateQueries(['contract', id_contrato]);
          queryClient.invalidateQueries(['contratos_noventa_dias']);
          clearValues();
          onClose();
        })
        .catch(error => {
          if (error.response.status === 403) {
            toast({
              title: 'Usuário sem permissão',
              description: 'Sem permissão para execução da operação.',
              status: 'error',
              duration: 3000,
              isClosable: true,
              position: 'top-right',
            });
          } else if (error.response.status === 413) {
            toast({
              title: `Tamanho de requisição excedida`,
              description: 'Limite máximo para tamanho de arquivos é de 5MB',
              status: 'error',
              duration: 3000,
              isClosable: true,
              position: 'top-right',
            });
          } else if (error.response.status === 400) {
            const errorsValidate = Object.entries(error.response.data);

            errorsValidate.forEach(err => {
              toast({
                title: `Erro ao ${
                  !visualization ? 'criar' : 'atualizar'
                } proposta`,
                description: String(err[1]),
                status: 'error',
                duration: 3000,
                isClosable: true,
                position: 'top-right',
              });
            });
          } else {
            toast({
              title: `Erro ao ${
                !visualization ? 'criar' : 'atualizar'
              } proposta`,
              description: 'Tente novamente',
              status: 'error',
              duration: 3000,
              isClosable: true,
              position: 'top-right',
            });
          }
        })
        .finally(() => {
          setFetching(false);
        });
    };

    return (
      <>
        <div
          role="button"
          onClick={handleOpen}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              handleOpen();
            }
          }}
          tabIndex={0}
        >
          {trigger}
        </div>
        <Drawer
          isOpen={isOpen}
          placement="right"
          onClose={handleClose}
          size="lg"
          closeOnOverlayClick={false}
        >
          <DrawerOverlay />
          <DrawerContent borderTopLeftRadius="md">
            <DrawerCloseButton isDisabled={isFetching} />
            <DrawerHeader ml="1">Analisar extensão de contrato</DrawerHeader>
            <DrawerBody overflow="scroll">
              <Stack gridGap={4} bg="white" minHeight="90%" width="100%">
                <Box
                  bg="gray.100"
                  borderColor="gray.200"
                  borderWidth="1px"
                  borderRadius={8}
                  borderTopWidth="1px"
                >
                  <Stack py="2" px="3">
                    <Flex
                      justifyContent="space-between"
                      alignContent="center"
                      alignItems="center"
                    >
                      <Text fontWeight="bold" color="#9246ce">
                        Análise Automática
                      </Text>
                      <Button
                        color="white"
                        background="gray.900"
                        _hover={{
                          bgColor: 'black',
                        }}
                        disabled={
                          automaticAnalysisIsFetching ||
                          isFetching ||
                          visualization
                        }
                        onClick={() => callAutomaticAnalysis()}
                      >
                        Executar Robô
                        {automaticAnalysisIsFetching && (
                          <Spinner style={{ marginLeft: '10px' }} />
                        )}
                      </Button>
                    </Flex>
                  </Stack>
                  <Divider m="0 !important" />
                  {automaticAnalysisIsFetching ? (
                    <Stack
                      gridGap={3}
                      textAlign="center"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Text>Carregando análise automática...</Text>
                    </Stack>
                  ) : automaticAnalysisError ? (
                    <Stack
                      gridGap={3}
                      textAlign="center"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Text>Erro ao carregar análise automática</Text>
                    </Stack>
                  ) : (
                    <Stack py="2" px="3">
                      <Text fontWeight="bold">
                        O contrato está elegível para extensão?
                      </Text>
                      <Text>
                        {automaticAnalysisData?.resultado ? 'Sim' : 'Não'}
                      </Text>
                      <Text fontWeight="bold">Justificativa Robô</Text>
                      <Text textAlign="justify">
                        Levando em consideração o contrato N°{' '}
                        {automaticAnalysisData?.nu_contrato}, as características{' '}
                        <span style={{ fontWeight: 'bold' }}>
                          {automaticAnalysisData?.most_relevant_features}
                        </span>{' '}
                        são as mais relevantes. Dessas características,{' '}
                        <span style={{ fontWeight: 'bold' }}>
                          {automaticAnalysisData?.validFeaturesCount ??
                            'nenhuma'}
                        </span>{' '}
                        est
                        {(automaticAnalysisData?.validFeaturesCount ?? 0) > 1
                          ? 'ão'
                          : 'á'}{' '}
                        de <span style={{ fontWeight: 'bold' }}>acordo</span>{' '}
                        com os limites estabelecidos. Sendo assim, opta-se por{' '}
                        <span style={{ fontWeight: 'bold' }}>
                          {automaticAnalysisData?.resultado ? '' : 'não'}{' '}
                          permitir a extensão do contrato
                        </span>
                        .
                      </Text>
                      <Accordion allowMultiple>
                        <AccordionItem
                          id={id_contrato.toString()}
                          borderStyle="none"
                        >
                          <AccordionButton p="0px">
                            <h2 style={{ width: '100%' }}>
                              <HStack justifyContent="space-between">
                                <Flex
                                  width="100%"
                                  alignItems="center"
                                  justifyContent="space-between"
                                >
                                  <Text p="2" fontWeight="bold" color="#9246ce">
                                    Ver detalhes da análise
                                  </Text>
                                  <AccordionIcon boxSize="20px" />
                                </Flex>
                              </HStack>
                            </h2>
                          </AccordionButton>
                          <AccordionPanel px="0" py="2">
                            <Table w="100%" minW="100px" type="secondary">
                              <Thead>
                                <Tr>
                                  <Th px="2" textAlign="center">
                                    Relevância
                                  </Th>
                                  <Th px="2">Característica</Th>
                                  <Th px="2" textAlign="right">
                                    Valor
                                  </Th>
                                  <Th px="0" />
                                  <Th px="2" textAlign="right">
                                    Limitante
                                  </Th>
                                  <Th px="2" textAlign="center">
                                    Resultado
                                  </Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                {automaticAnalysisData?.features?.length ? (
                                  automaticAnalysisData.features.map(
                                    feature => (
                                      <Tr key={feature.id} fontSize="14px">
                                        <Td
                                          fontWeight="bold"
                                          px="2"
                                          textAlign="center"
                                          style={{ borderColor: '#e5e5e6' }}
                                        >
                                          {feature.relevancia}°
                                        </Td>
                                        <Td
                                          fontWeight="bold"
                                          px="2"
                                          style={{ borderColor: '#e5e5e6' }}
                                        >
                                          {feature.description}
                                        </Td>
                                        <Td
                                          whiteSpace="nowrap"
                                          px="2"
                                          textAlign="right"
                                          style={{ borderColor: '#e5e5e6' }}
                                        >
                                          {feature.formattedValue}
                                          {feature.signal}
                                        </Td>
                                        <Td
                                          px="2"
                                          style={{ borderColor: '#e5e5e6' }}
                                        >
                                          {feature.operador_label}
                                        </Td>
                                        <Td
                                          whiteSpace="nowrap"
                                          px="2"
                                          textAlign="right"
                                          style={{ borderColor: '#e5e5e6' }}
                                        >
                                          {feature.formattedLimit}
                                          {feature.signal}
                                        </Td>
                                        <Td
                                          px="2"
                                          justifyItems="center"
                                          alignItems="center"
                                          style={{ borderColor: '#e5e5e6' }}
                                        >
                                          {feature.resultado ? (
                                            <FiCheck size={18} color="green" />
                                          ) : (
                                            <FiX size={18} color="red" />
                                          )}
                                        </Td>
                                      </Tr>
                                    ),
                                  )
                                ) : (
                                  <Tr>
                                    <Td colSpan={5} textAlign="center">
                                      <Text textAlign="center">
                                        Não há faturas.
                                      </Text>
                                    </Td>
                                  </Tr>
                                )}
                              </Tbody>
                            </Table>
                          </AccordionPanel>
                        </AccordionItem>
                      </Accordion>
                      <FormControl>
                        <FormLabel>
                          Você está de acordo com o resultado da análise
                          automática?
                        </FormLabel>
                        <RadioGroup
                          value={approveAutoAnalysis}
                          onChange={e =>
                            handleApproveAutoAnalysis(e, automaticAnalysisData!)
                          }
                          colorScheme="b"
                          isDisabled={visualization}
                        >
                          <Stack direction="row" spacing={10}>
                            <Radio value="1">Sim</Radio>
                            <Radio value="2">Não</Radio>
                          </Stack>
                        </RadioGroup>
                      </FormControl>
                      {approveAutoAnalysis === '2' && (
                        <FormControl
                          isInvalid={errors.disapproveReason}
                          isRequired
                        >
                          <FormLabel>Informe o motivo</FormLabel>
                          <Textarea
                            name="disapproveReason"
                            resize="none"
                            error={errors?.disapproveReason}
                            value={disapproveReason}
                            onChange={e => handleDisapproveReason(e)}
                            fontSize="15px"
                            isDisabled={visualization}
                          />
                        </FormControl>
                      )}
                    </Stack>
                  )}
                </Box>
                {!automaticAnalysisIsFetching && (
                  <Box
                    bg="gray.100"
                    borderColor="gray.200"
                    borderWidth="1px"
                    borderRadius={8}
                    borderTopWidth="1px"
                  >
                    <Stack py="2" px="3">
                      <Text py="2" px="2" fontWeight="bold" color="#9246ce">
                        Análise do Usuário
                      </Text>
                      {automaticAnalysisError && ( // Mostra opção quando o robô retorna algum erro.
                        <FormControl isRequired>
                          <FormLabel>
                            O contrato é elegível para extensão?
                          </FormLabel>
                          <RadioGroup
                            value={elegivel}
                            onChange={e => handleElegivel(e)}
                            colorScheme="b"
                            isDisabled={visualization}
                          >
                            <Stack direction="row" spacing={10}>
                              <Radio value="1">Sim</Radio>
                              <Radio value="2">Não</Radio>
                            </Stack>
                          </RadioGroup>
                        </FormControl>
                      )}
                      {elegivel === '1' &&
                      !isLoadingEquipamentos &&
                      podeEstenderElegivel ? (
                        <Stack gridGap={2}>
                          <Stack gridGap={1}>
                            <ContractEquipamentValues
                              valor_mensal_contrato={getUltimoValorContrato(
                                contract,
                              )}
                              visualizacao={visualization}
                              equipamentos={equipamentos}
                              changeListaEquipamentos={e => setEquipamentos(e)}
                            />
                            <FormControl
                              isRequired
                              isInvalid={errors.descontos}
                            >
                              <FormLabel>
                                Prazo máximo de extensão e desconto
                              </FormLabel>
                              {discountList.length > 0 ? (
                                <Stack>
                                  <Stack>
                                    {discountList.map(desconto => (
                                      <FormControl
                                        isInvalid={
                                          errors[`descontos${desconto.id}`]
                                        }
                                        w={350}
                                        key={desconto.id}
                                      >
                                        <Flex height="55px">
                                          <Checkbox
                                            colorScheme="b"
                                            value={desconto.id}
                                            onChange={() =>
                                              handleCheckbox(desconto)
                                            }
                                            isChecked={existsInCheckedItems(
                                              desconto,
                                            )}
                                            isDisabled={visualization}
                                          >
                                            <>
                                              {desconto.tempo_extensao}
                                              {desconto.tempo_extensao > 1
                                                ? ' meses'
                                                : ' mês'}
                                              {!visualization && (
                                                <Text
                                                  fontSize="10px"
                                                  marginBottom="-15px"
                                                >
                                                  Desconto permitido:{' '}
                                                  {Number(
                                                    desconto.desconto_minimo,
                                                  )
                                                    .toString()
                                                    .replace('.', ',')}{' '}
                                                  a{' '}
                                                  {Number(
                                                    desconto.desconto_maximo,
                                                  )
                                                    .toString()
                                                    .replace('.', ',')}{' '}
                                                  %
                                                </Text>
                                              )}
                                            </>
                                          </Checkbox>
                                          <Spacer />
                                          <Stack
                                            direction="row"
                                            w="40%"
                                            alignItems="center"
                                          >
                                            <ChakraInput
                                              marginBottom="-15px"
                                              bg="gray.100"
                                              borderColor={
                                                errors[
                                                  `descontos${desconto.id}`
                                                ]
                                                  ? 'red'
                                                  : 'gray.300'
                                              }
                                              _hover={{
                                                borderColor: 'gray.500',
                                              }}
                                              _placeholder={{
                                                color: 'gray.500',
                                              }}
                                              value={
                                                desconto.formattedDescontoPadrao
                                              }
                                              onChange={e =>
                                                handleDesconto(e, desconto)
                                              }
                                              isDisabled={visualization}
                                            />
                                            <Text pt="15px">%</Text>
                                          </Stack>
                                        </Flex>
                                        {errors[`descontos${desconto.id}`] && (
                                          <FormErrorMessage
                                            justifyContent="start"
                                            marginBottom="-15px"
                                          >
                                            {
                                              errors[`descontos${desconto.id}`]
                                                ?.message
                                            }
                                          </FormErrorMessage>
                                        )}
                                      </FormControl>
                                    ))}
                                  </Stack>
                                  {!!errors.descontos && (
                                    <FormErrorMessage>
                                      {errors.descontos?.message}
                                    </FormErrorMessage>
                                  )}
                                  <Alert
                                    bg="#f7f2fa"
                                    borderRadius="md"
                                    color="#9246ce"
                                    fontSize="sm"
                                    py={1}
                                    px={2}
                                    mt={4}
                                    mb={2}
                                  >
                                    <AlertTitle>Atenção:</AlertTitle>
                                    <AlertDescription>
                                      Esse desconto será adicionado ao desconto
                                      de aceite através do portal.
                                    </AlertDescription>
                                  </Alert>
                                </Stack>
                              ) : (
                                <Text>
                                  Não há desconto padrão cadastrado!{' '}
                                  <Link
                                    color="gray.800"
                                    sx={{
                                      textDecor: 'underline',
                                      fontWeight: 'bold',
                                    }}
                                    href={ROUTER_PATHS.PORTAL.ADMIN.DISCOUNT}
                                  >
                                    Criar desconto?
                                  </Link>
                                </Text>
                              )}
                            </FormControl>
                            {!contract?.nu_termo_segue_padrao && (
                              <FormControl isInvalid={errors.nu_termo}>
                                <FormLabel
                                  justifyContent="space-between"
                                  display="flex"
                                >
                                  <HStack>
                                    <Text>
                                      Informe o número do termo do Contrato
                                    </Text>
                                    <Text color="red">*</Text>
                                  </HStack>
                                  <Tooltip
                                    hasArrow
                                    label={
                                      'Esse número precisa ser inserido no formato: "CNPJ - sequência de dígitos". Ex:12345678000123-000'
                                    }
                                    bg="gray"
                                    shouldWrapChildren
                                  >
                                    <Icon as={FaInfoCircle} color="gray.900" />
                                  </Tooltip>
                                </FormLabel>
                                <Input
                                  name="nu_termo"
                                  error={errors?.nu_termo}
                                  value={nuTermo}
                                  onChange={e => handleNuTermo(e)}
                                  isDisabled={visualization}
                                  onBlur={() => verificarPodeAnexarTermo()}
                                />
                              </FormControl>
                            )}
                          </Stack>
                          <FormControl isRequired>
                            <FormLabel>
                              Disponibilizar manutenção preventiva?
                            </FormLabel>
                            <RadioGroup
                              value={manutencao}
                              onChange={e => setManutencao(e)}
                              colorScheme="b"
                              isDisabled={visualization}
                            >
                              <Stack direction="row" spacing={10}>
                                <Radio value="1">Sim</Radio>
                                <Radio value="2">Não</Radio>
                              </Stack>
                            </RadioGroup>
                          </FormControl>
                          {podeAnexarTermo && (
                            <FileUploader
                              isDisabled={visualization || isFetching}
                              fileName={nomeArquivo}
                              onChange={handleFileChange}
                              clearFile={clearFile}
                              label="Anexar termo de extensão"
                              errors={errors.arquivo}
                              helpText="Informar o termo de extensão em formato PDF, máximo 5MB."
                            />
                          )}
                          <FormControl>
                            <FormLabel fontSize="20px">
                              Renovação automática
                            </FormLabel>
                            <Checkbox
                              colorScheme="b"
                              isChecked={renovacao}
                              onChange={handleRenovacao}
                            >
                              Permitir renovação automática caso o cliente não
                              responda em até 90 dias.
                            </Checkbox>
                          </FormControl>
                        </Stack>
                      ) : elegivel === '1' &&
                        !isLoadingEquipamentos &&
                        !podeEstenderElegivel ? (
                        <Text>Não há equipamentos para o contrato.</Text>
                      ) : elegivel === '1' && isLoadingEquipamentos ? (
                        <Stack
                          gridGap={3}
                          textAlign="center"
                          justifyContent="center"
                          alignItems="center"
                        >
                          <Spinner />
                          <Text>Carregando equipamentos...</Text>
                        </Stack>
                      ) : elegivel === '2' ? (
                        <>
                          {id_contrato && (
                            <Accordion allowToggle>
                              <AccordionItem>
                                <AccordionButton bgColor="#F2F2F2">
                                  <AccordionIcon mr={3} />
                                  <Box
                                    as="span"
                                    flex="1"
                                    textAlign="left"
                                    fontSize={13}
                                    fontWeight={500}
                                  >
                                    Visualizar sugestões de novos equipamentos
                                  </Box>
                                </AccordionButton>
                                <AccordionPanel pb={4} bgColor="#F2F2F2">
                                  <EquipmentSuggestion
                                    id_contrato={id_contrato}
                                  />
                                </AccordionPanel>
                              </AccordionItem>
                            </Accordion>
                          )}
                          <Stack gridGap={1}>
                            <Flex>
                              <ReactSelect
                                isMulti
                                isSearchable
                                label="Motivo do contrato não ser estendido"
                                placeholder="Selecione"
                                error={errors.motivos}
                                options={reasonsData}
                                value={reasons}
                                maxW="90%"
                                required
                                isDisabled={visualization}
                                onChange={changes =>
                                  handleReasonsChanges(changes as SelectItem[])
                                }
                              />
                              {!visualization && (
                                <Flex h="auto">
                                  <ReasonForm align={!!errors?.motivos} />
                                </Flex>
                              )}
                            </Flex>
                            <FormControl isInvalid={errors.motivo} isRequired>
                              <FormLabel fontSize="14px">
                                Compartilhe com o cliente o motivo do contrato
                                não ser estendido
                              </FormLabel>
                              <Textarea
                                name="descricao"
                                resize="none"
                                error={errors?.motivo}
                                value={motivo}
                                onChange={e => handleMotivo(e)}
                                fontSize="15px"
                                isDisabled={visualization}
                              />
                            </FormControl>
                            <FormControl
                              isInvalid={errors.dataColeta}
                              isRequired
                              w="50%"
                            >
                              <FormLabel fontSize="14px">
                                Selecione a data limite para a coleta
                              </FormLabel>
                              <Datepicker
                                isDisabled={visualization}
                                onChange={e => handleDataColeta(e)}
                                selectedDate={dataColeta}
                                error={errors.dataColeta}
                              />
                            </FormControl>
                          </Stack>
                          <FormControl>
                            <FormLabel fontSize="20px">
                              Selecione os serviços adicionais necessários:
                            </FormLabel>
                            <Stack>
                              <Checkbox
                                colorScheme="b"
                                isChecked={servicoInspecao}
                                onChange={() => {
                                  setServicoInspecao(!servicoInspecao);
                                }}
                                isDisabled={visualization}
                              >
                                Inspeção
                              </Checkbox>
                              <Checkbox
                                colorScheme="b"
                                isChecked={servicoDesinstalacao}
                                onChange={() => {
                                  setServicoDesinstalacao(
                                    !servicoDesinstalacao,
                                  );
                                }}
                                isDisabled={visualization}
                              >
                                Desinstalação
                              </Checkbox>
                              <Checkbox
                                colorScheme="b"
                                isChecked={servicoEmbalagem}
                                onChange={() => {
                                  setServicoEmbalagem(!servicoEmbalagem);
                                }}
                                isDisabled={visualization}
                              >
                                Embalagem
                              </Checkbox>
                            </Stack>
                          </FormControl>
                        </>
                      ) : null}
                      {visualization && (
                        <Alert
                          bg="#f7f2fa"
                          borderRadius="md"
                          color="#9246ce"
                          fontSize="sm"
                          py={1}
                          px={2}
                          my={2}
                        >
                          <AlertTitle>Atenção:</AlertTitle>
                          <AlertDescription>
                            E-mail enviado ao cliente. Aguardando resposta.
                          </AlertDescription>
                        </Alert>
                      )}
                      <Divider orientation="horizontal" />
                      {!visualization && !!elegivel && (
                        <Text size="sm">
                          Ao confirmar, avisaremos ao cliente que o Contrato{' '}
                          {elegivel === '2' ? 'não' : ''} está elegível para
                          extensão
                          {elegivel === '2'
                            ? '. E antes do Contrato vencer, enviaremos as instruções para a coleta dos equipamentos.'
                            : ' conforme os prazos que você selecionou.'}
                        </Text>
                      )}
                      {!!elegivel && (
                        <Text fontSize="sm" color="gray.500">
                          <span style={{ fontWeight: 'bold', color: 'red' }}>
                            *
                          </span>{' '}
                          Campos obrigatórios
                        </Text>
                      )}
                    </Stack>
                  </Box>
                )}
              </Stack>
              <Flex justifyContent="end" mt={2}>
                <Button
                  type="submit"
                  onClick={handleSubmit(handleCreate)}
                  color="white"
                  background="gray.900"
                  size="lg"
                  _hover={{
                    bgColor: 'black',
                  }}
                  isDisabled={
                    isFetching ||
                    isLoadingEquipamentos ||
                    automaticAnalysisIsFetching ||
                    (elegivel === '1' && equipamentos.length === 0)
                  }
                  display={elegivel === '2' && visualization ? 'none' : ''}
                >
                  {visualization ? 'Salvar' : 'Confirmar'}{' '}
                  {isFetching && <Spinner style={{ marginLeft: '10px' }} />}
                </Button>
                <Button
                  type="button"
                  onClick={handleClose}
                  color="black"
                  size="lg"
                  background="transparent"
                  ml="10px"
                  isDisabled={isFetching}
                >
                  Cancelar
                </Button>
              </Flex>
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      </>
    );
  };
